import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityTraffic/img/1.avif';
import image2 from '@src/assets/images/solution/cityTraffic/img/2.avif';
import image3 from '@src/assets/images/solution/cityTraffic/img/3.avif';
import image4 from '@src/assets/images/solution/cityTraffic/img/4.avif';
import image5 from '@src/assets/images/solution/cityTraffic/img/5.avif';
import image6 from '@src/assets/images/solution/cityTraffic/img/6.avif';
import image7 from '@src/assets/images/solution/cityTraffic/img/7.avif';
import image8 from '@src/assets/images/solution/cityTraffic/img/8.avif';
import image9 from '@src/assets/images/solution/cityTraffic/img/9.avif';

export default {
  type: '交通解决方案',

  banner: {
    title: '基于AI的车辆分析，智能管理高速公路服务区停车',
    desc: '通过PTZ AI摄像头实时识别停车区域内的车辆位置和车牌号，缓解服务区的拥堵，提高运营效率，提升客户使用体验。',
  },

  video: {
    title: '基于AI的停车分析，同时优化运营与便利性',
    desc: 'AI摄像头实时识别车辆位置和车牌号，实时显示停车位使用情况，并与用户信息联动，实现智能化运营。',
    play: video,
  },

  func: [
    {
      theme: '基于AI的车辆追踪与环境适应',
      title: 'PTZ摄像头覆盖大范围高精度监控',
      desc: '通过在灯塔上安装多台PTZ摄像头，全面覆盖宽广的停车区域。对需要监控的区域可进行高倍变焦，实时追踪停车流和拥堵区域。',
      sub1: '实时状态把握',
      icon1: IconClockGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '基于现场数据快速提升AI模型性能',
      desc: 'ORBRO通过实时数据增强技术，快速将物体识别模型适应停车场现场环境，摄像头安装后短时间内显著提升识别率。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '高精度提供',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '夜间/低光环境下稳定识别',
      desc: '即使在夜间或光线较暗的条件下，也能准确捕捉车辆的快速移动，结合低光优化算法和NIR硬件支持，确保识别稳定。',
      sub1: '危险资产指定',
      icon1: IconWarningGray,
      sub2: '设置应对方式',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: '恶劣天气下保持稳定性能',
      desc: '即使在雪、雨等复杂天气条件下，仍可维持车辆追踪性能，应用适应天气变化的深度学习过滤算法。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '分析室内区域人流',
      desc: '停车场相邻的室内空间通过鱼眼摄像头分析客户人流，通过分析停车与店铺的关联提升商业利用价值。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: '运营效率与风险检测自动化',
      title: '车辆出入口流量分析',
      desc: '自动收集出入口车辆统计数据，预测不同时段的拥堵度，为优化运营时间和设施改进提供依据。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '逆行检测与警报',
      desc: '车辆若逆行，系统将立即发出警报，快速应对危险状况。<br/><br/> • 检测特定区域内逆向移动的物体<br/><br/> • 可在服务区出口等位置检测逆行<br/><br/> • 逆行发生时提供警报功能（移动端、监控中心联动）',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '长时间滞留车辆分析',
      desc: '检测在快速通行的出入口长时间滞留的行人并发出警报，防止事故风险，同时分析车辆与行人之间的相互作用风险。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: '基于视频ROI的性能优化与隐私保护',
      desc: '仅保留所需画面，通过设置ROI（感兴趣区域）去除不必要的视频，提升计算速度，并对敏感区域进行去标识化，保护隐私。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: '多样功能',
    desc: '医疗废弃物管理不容疏忽。哪怕是小小的疏忽与失误也可能导致严重的医疗事故。因此需要极其精密的管理和保障安全。<br/>ORBRO为构建安全高效的医疗设施提供多种功能。',

    data: [
      { icon: IconBinocularsGray, title: 'PTZ车辆追踪', desc: '高倍PTZ广域追踪。' },
      { icon: IconChartBarGray, title: 'AI目标识别', desc: '车、行人自动识别追踪。' },
      { icon: IconClockGray, title: '夜间低照适应', desc: '暗处也稳定识别。' },
      { icon: IconChartBarGray, title: '恶劣天气适应', desc: '雨雪中仍精准追踪。' },
      { icon: IconChartRadius, title: '室内人流分析', desc: '鱼眼分析人流拥堵区。' },
      { icon: IconRoute, title: '出入量分析', desc: '按时段统计优化流量。' },
      { icon: IconZoneGray, title: 'ROI去除多余视频', desc: '只保留必要区域。' },
      { icon: IconWarning, title: '逆行检测报警', desc: '逆行即刻报警管理。' },
      { icon: IconWarning, title: '长时间停留检测', desc: '行人长停自动警示。' },
      { icon: IconDashboard, title: 'AI看板可视化', desc: '全流量及异常即时显示。' },
    ],
  },

  system: {
    title: '系统组成',
    img: rtlsSystem,
  },

  productTitle: '产品组成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
